<template>
  <article>
    <section>
      <div class="container mx-auto text-center">
        <img src="@/assets/img/404.jpg" alt="" class="mx-auto">
        <p>
          A pagina que você está buscando não foi encontrada
        </p>
      </div>
    </section>
  </article>
</template>

<script>
export default {
  mounted () {
    this.$store.commit('LOADER')
  }

}
</script>

<style>
body{
  background: #fff;
}
</style>
